
const digest = '0ad71e3e14a8c958f44965ff665df9f174f3aeaf61a8921292f3441d1a180a02';
const classes = {"controls":"_controls_1eek5_1"};
const css = `._controls_1eek5_1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  